import React, { useEffect, useState } from "react";
import { PaymentMethod, PaymentType, ScreenSize } from "../../utils/constants";
import useSystemHook from "../../hooks/SystemHook";
import {
  Alert,
  Avatar,
  Box,
  Button,
  List,
  ListItem,
  Paper,
  Typography,
} from "@mui/material";
import PageHeader from "../PageHeader";

const Payment = ({
  accountCreditPaymentOrderInfo,
  tecfinityAvailableCredit,
  gotoPaymentPayfastPage,
  gotoPaymentAccountCredit,
  gotoPaymentEftPage,
  gotoPaymentCreditCardOnCollectionPage,
  paymentMethods,
}) => {
  const { screenSize } = useSystemHook();
  const [recommendedPaymentMethod, setRecommendedPaymentMethod] = useState(
    PaymentMethod.PayFast,
  );

  // useEffect(() => window.scrollTo(0, 0), []);

  useEffect(() => {
    if (tecfinityAvailableCredit >= accountCreditPaymentOrderInfo?.amount) {
      setRecommendedPaymentMethod(PaymentMethod.AccountCredit);
    }
  }, [tecfinityAvailableCredit, accountCreditPaymentOrderInfo]);

  const paymentOptions = [
    {
      type: PaymentType.PayFast,
      label: "Pay via Payfast",
      image: "https://argusweb.azureedge.net/argus-web/payment/payfast.svg",
      action: gotoPaymentPayfastPage,
      method: PaymentMethod.PayFast,
    },
    {
      type: PaymentType.AccountCredit,
      label: "Pay with Account Credit",
      image: "https://argusweb.azureedge.net/argus-web/logo.svg",
      action: gotoPaymentAccountCredit,
      method: PaymentMethod.AccountCredit,
      condition: !!tecfinityAvailableCredit,
    },
    {
      type: PaymentType.EFT,
      label: "Pay via EFT",
      image: "https://argusweb.azureedge.net/argus-web/payment/eft.svg",
      action: gotoPaymentEftPage,
      method: PaymentMethod.EFT,
    },
    {
      type: PaymentType.CreditCardOnCollection,
      label: "Pay via Credit Card on Collection",
      image: "https://argusweb.azureedge.net/argus-web/payment/creditcard.svg",
      action: gotoPaymentCreditCardOnCollectionPage,
      method: PaymentMethod.CardOnCollection,
    },
  ];

  const availablePaymentOptions = !!paymentMethods
    ? paymentOptions.filter(
        (option) =>
          paymentMethods.includes(option.type) &&
          (option.condition === undefined || option.condition),
      )
    : [];

  const renderPaymentOption = (option) => (
    <ListItem
      key={option.type}
      sx={{ display: "flex", alignItems: "center", padding: "12px" }}
    >
      <Avatar
        variant="square"
        alt={option.label}
        src={option.image}
        sx={{
          width: screenSize === ScreenSize.Desktop ? 150 : 60,
          height: screenSize === ScreenSize.Desktop ? 50 : 40,
          mr: 2,
        }}
      />
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          {option.label}
        </Typography>
        {recommendedPaymentMethod === option.method && (
          <Typography variant="caption" color="error">
            Recommended
          </Typography>
        )}
      </Box>
      <Button
        variant="contained"
        color="error"
        size="small"
        onClick={option.action}
      >
        Pay
      </Button>
    </ListItem>
  );

  return (
    <>
      <PageHeader title="Payment" />
      <Box
        sx={{
          minHeight: screenSize === ScreenSize.Desktop ? "100vh" : "50vh",
          backgroundColor: "#f7f7f7",
          padding: screenSize === ScreenSize.Desktop ? "2rem" : "16px",
        }}
      >
        <Typography
          variant="body2"
          sx={{ mb: 2, textAlign: "center", fontWeight: "bold" }}
        >
          Choose your payment method
        </Typography>
        <Paper elevation={3} sx={{ padding: 2, mb: 2 }}>
          {!!paymentMethods && availablePaymentOptions.length > 0 && (
            <List>{availablePaymentOptions.map(renderPaymentOption)}</List>
          )}
          {!!paymentMethods && availablePaymentOptions.length === 0 && (
            <Alert severity="warning">
              <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
                No payment methods are available for this order
              </Typography>
              <Typography variant="caption">
                Please contact our support team for help completing this order.
              </Typography>
            </Alert>
          )}
        </Paper>
      </Box>
    </>
  );
};

export default Payment;
